<template>
  <div class="app-container">
    <div class="filter-container">
<!--      <el-button class="filter-item" type="primary" @click="handleCreate">新增</el-button>-->

      <el-input class="filter-item" v-model="listQuery.name" placeholder="名称" style="width: 220px;" clearable/>

      <el-button class="filter-item" type="primary" @click="handleFilter">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="ID" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>

      <el-table-column label="开始时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.start_time }}
        </template>
      </el-table-column>

      <el-table-column label="结束时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.end_time }}
        </template>
      </el-table-column>

      <el-table-column label="男生餐价" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.boy_price }}
        </template>
      </el-table-column>

      <el-table-column label="女生餐价" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.girl_price }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30,50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <!-- 详情 -->
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="60%" :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" :model="form" label-width="150px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" :disabled="!!form.id"></el-input>
        </el-form-item>

        <el-form-item label="服务时间">
          <el-time-picker is-range v-model="timeArr" format="HH:mm" value-format="HH:mm" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-time-picker>
        </el-form-item>

        <el-form-item label="男生餐价" prop="boy_price">
          <el-input-number v-model="form.boy_price" controls-position="right" :min="0" :precision="2"></el-input-number>
        </el-form-item>

        <el-form-item label="女生餐价" prop="girl_price">
          <el-input-number v-model="form.girl_price" controls-position="right" :min="0" :precision="2"></el-input-number>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          name: "",
        },
        dialogFormVisible: false,
        dialogStatus: "",
        textMap: {
          update: "修改",
          create: "新增",
        },
        btnLoading: false,
        form:{
          id: "",
          name: "",
          start_time: "",
          end_time: "",
          boy_price: 0,
          girl_price: 0,
        },
        rules: {
          name: [{ required: true, message: "名称不能为空", trigger: "change" }],
          boy_price: [{ required: true, message: "男生餐价不能为空", trigger: "change" }],
          girl_price: [{ required: true, message: "女生餐价不能为空", trigger: "change" }],
        },
        timeArr: null,
      };
    },
    created() {
      this.getList();
    },
    computed: {
      ...mapGetters(["schools","school_id","user"])
    },
    watch: {
      timeArr(newVal, oldVal) {
        if (newVal) {
          this.form.start_time = newVal[0];
          this.form.end_time = newVal[1];
        } else {
          this.form.start_time = "";
          this.form.end_time = "";
        }
      }
    },
    methods: {
      getList() {
        this.listLoading = true;
        request({
          url: "/api/backend/systemCateredTime/list",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.list = response.data.data;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      resetForm() {
        this.form = {
          id: "",
          name: "",
          start_time: "",
          end_time: "",
          boy_price: 0,
          girl_price: 0,
        }
        this.btnLoading = false;
        this.timeArr = null;
      },
      handleCreate() {
        this.resetForm()
        this.dialogStatus = "create"
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      handleUpdate(row) {
        this.resetForm()
        this.form = Object.assign({}, row)
        this.timeArr = [this.form.start_time,this.form.end_time];
        this.dialogStatus = "update"
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      saveData() {
        if (!this.form.start_time) {
          this.$message({
            type: "warning",
            message: "开始时间不能为空"
          });
          return;
        }
        if (!this.form.end_time) {
          this.$message({
            type: "warning",
            message: "结束时间不能为空"
          });
          return;
        }
        if (this.form.end_time < this.form.start_time) {
          this.$message({
            type: "warning",
            message: "结束时间不能低于开始时间",
          });
          return;
        }

        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.btnLoading = true
            request({
              url: "/api/backend/systemCateredTime/save",
              method: "post",
              data: this.form
            }).then(() => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.getList();
            }).catch(() => {
              this.btnLoading = false
            })
          }
        })
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
